var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CsButton,{staticClass:"mb-2 ml-1",attrs:{"is-icon-only":"","variant":"subtle","size":"sm"},on:{"click":function($event){return _vm.$emit('click')}}},[_c(_setup.CsIcon,{staticClass:"h-4 w-4",attrs:{"name":"reply"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }